import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';

export interface IComunidadesAutonomasCupsProps {
    
}

export interface IComunidadesAutonomasCupsState {
    cupsLuz: any[];
    cupsGas: any[];
    cupsLuzSex: any[];
    cupsGasSex: any[];
}

export default class ComunidadesAutonomasCups extends React.Component<IComunidadesAutonomasCupsProps, IComunidadesAutonomasCupsState> {
    public constructor(props: IComunidadesAutonomasCupsProps) {
        super(props);

        this.state = {
            cupsLuz: [],
            cupsGas: [],
            cupsLuzSex: [],
            cupsGasSex: []
        }
    }

    componentDidMount(): void {
        this.GetCupsLuz();
        this.GetCupsGas();
        this.GetCupsLuzMen();
        this.GetCupsGasMen();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <Typography variant="h5" component="div">
                                CUPS
                            </Typography>
                        </Grid>
                        <Grid item xs={8}>
                            <Box display={'flex'} justifyContent={'space-between'}>
                                <Typography variant="h5" component="div" textAlign={'right'}>
                                    CUPS Luz
                                </Typography>
                                <Stack direction={'row'}>
                                    <ManIcon style={{fontSize: '16px', color: Common.MAN_BORDER_COLOR}}/>
                                    <Typography variant="body2">
                                        {
                                            this.GetTotalMen(this.state.cupsLuzSex)
                                        }
                                    </Typography>
                                    <WomanIcon style={{fontSize: '16px', color: Common.WOMAN_BORDER_COLOR}}/>
                                    <Typography variant="body2">
                                        {
                                            this.GetTotalWomen(this.state.cupsLuzSex)
                                        }
                                    </Typography>
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <PieChart
                                series={[
                                    { data: this.state.cupsLuz, innerRadius: 40, outerRadius: 80 },
                                    { data: this.state.cupsGas, innerRadius: 100, outerRadius: 120 }
                                ]}
                                margin={{
                                    left: 50,
                                    right: 50,
                                    bottom: 100,
                                    top: 50
                                }}
                                height={350}
                                slotProps={
                                    {
                                        legend: {
                                            hidden: true
                                        }
                                    }
                                }
                            />
                            <Stack direction={'row'} justifyContent={'center'}>
                                <div style={{backgroundColor: '#9667e0', width: '20px', height: '6px', position: 'relative', top: '5px', margin: '0px 10px'}}></div>
                                <Typography variant='caption'>
                                    CUPS Luz
                                </Typography>
                                <div style={{backgroundColor: '#ffa86b', width: '20px', height: '6px', position: 'relative', top: '5px', margin: '0px 10px'}}></div>
                                <Typography variant='caption'>
                                    CUPS Gas
                                </Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={8}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <LineChart
                                        dataset={this.state.cupsLuzSex}
                                        xAxis={[{ scaleType: 'point', dataKey: 'comunidadAutonoma' }]}
                                        series={[
                                            { dataKey: 'hombres', label: 'Hombres', color: Common.MAN_BORDER_COLOR },
                                            { dataKey: 'mujeres', label: 'Mujeres', color: Common.WOMAN_BORDER_COLOR}
                                        ]}
                                        height={250}
                                        slotProps={
                                            {
                                                legend: {
                                                    hidden: true
                                                }
                                            }
                                        }
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Box display={'flex'} justifyContent={'space-between'}>
                                        <Typography variant="h5" component="div" textAlign={'right'}>
                                            CUPS Gas
                                        </Typography>
                                        <Stack direction={'row'}>
                                            <ManIcon style={{fontSize: '16px', color: Common.MAN_BORDER_COLOR}}/>
                                            <Typography variant="body2">
                                                {
                                                    this.GetTotalMen(this.state.cupsGasSex)
                                                }
                                            </Typography>
                                            <WomanIcon style={{fontSize: '16px', color: Common.WOMAN_BORDER_COLOR}}/>
                                            <Typography variant="body2">
                                                {
                                                    this.GetTotalWomen(this.state.cupsGasSex)
                                                }
                                            </Typography>
                                        </Stack>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <LineChart
                                        dataset={this.state.cupsGasSex}
                                        xAxis={[{ scaleType: 'point', dataKey: 'comunidadAutonoma' }]}
                                        series={[
                                            { dataKey: 'hombres', label: 'Hombres', color: Common.MAN_BORDER_COLOR },
                                            { dataKey: 'mujeres', label: 'Mujeres', color: Common.WOMAN_BORDER_COLOR}
                                        ]}
                                        height={250}
                                        margin={{
                                            bottom: 100
                                        }}
                                        slotProps={
                                            {
                                                legend: {
                                                    direction: 'row',
                                                    position: {
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    },
                                                    itemMarkWidth: 20,
                                                    itemMarkHeight: 6,
                                                    markGap: 5,
                                                    itemGap: 10,
                                                    labelStyle: {
                                                        fontSize: 11
                                                    }
                                                }
                                            }
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }

    private GetCupsLuz() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/field/cupsluz`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const length = response.length;
            
            const palletteMap = Common.FIELD_PALETTE_MAP;
            let startColor = '#ffe000';
            let endColor = '#ff9900';

            const fieldColors = palletteMap.find((fieldColor: any) => {
                return fieldColor.field.toLowerCase() == 'cupsluz';
            });

            if(fieldColors != null) {
                startColor = fieldColors.colors[0];
                endColor = fieldColors.colors[1]
            }

            const gradientArray = new Gradient()
            .setColorGradient(startColor, endColor)
            .setMidpoint(length > 1 ? length : 2)
            .getColors();

            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.id = i;
                dataItem.label = response[i].comunidadAutonoma;
                dataItem.value = response[i].total;
                dataItem.color = gradientArray[i];

                data.push(dataItem);
            }

            this.setState(
                {
                    cupsLuz: data
                }
            )
        })
    }

    private GetCupsGas() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/field/cupsgas`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const length = response.length;
            
            const palletteMap = Common.FIELD_PALETTE_MAP;
            let startColor = '#ffe000';
            let endColor = '#ff9900';

            const fieldColors = palletteMap.find((fieldColor: any) => {
                return fieldColor.field.toLowerCase() == 'cupsgas';
            });

            if(fieldColors != null) {
                startColor = fieldColors.colors[0];
                endColor = fieldColors.colors[1]
            }

            const gradientArray = new Gradient()
            .setColorGradient(startColor, endColor)
            .setMidpoint(length > 1 ? length : 2)
            .getColors();

            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.id = i;
                dataItem.label = response[i].comunidadAutonoma;
                dataItem.value = response[i].total;
                dataItem.color = gradientArray[i];

                data.push(dataItem);
            }

            this.setState({
                cupsGas: data
            })
        })
    }

    private GetCupsLuzMen() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/h/cupsluz`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                dataItem.hombres = response[i].total;
                dataItem.mujeres = 0;

                data.push(dataItem);
            }

            this.GetCupsLuzWomen(data);
        })
    }

    private GetCupsLuzWomen(sourceData: any[]) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/m/cupsluz`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = JSON.parse(JSON.stringify(sourceData));

            for(let i = 0; i < response.length; i++) {
                let dataItem: any = data.find((value: any) => {
                    return value.comunidadAutonoma == response[i].comunidadAutonoma;
                });

                if (dataItem == null) {
                    dataItem = {};
                    dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                    dataItem.hombres = 0;

                    data.push(dataItem);
                }

                dataItem.mujeres = response[i].total;
            }

            data.sort((a, b) => {
                if(a.comunidadAutonoma < b.comunidadAutonoma) { return -1; }
                if(a.comunidadAutonoma > b.comunidadAutonoma) { return 1; }
                return 0;
            });
            
            this.setState({
                cupsLuzSex: data
            })
        })
    }

    private GetCupsGasMen() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/h/cupsgas`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                dataItem.hombres = response[i].total;
                dataItem.mujeres = 0;

                data.push(dataItem);
            }

            this.GetCupsGasWomen(data);
        })
    }

    private GetCupsGasWomen(sourceData: any[]) {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total/sex/m/cupsgas`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = JSON.parse(JSON.stringify(sourceData));

            for(let i = 0; i < response.length; i++) {
                let dataItem: any = data.find((value: any) => {
                    return value.comunidadAutonoma == response[i].comunidadAutonoma;
                });

                if (dataItem == null) {
                    dataItem = {};
                    dataItem.comunidadAutonoma = response[i].comunidadAutonoma;
                    dataItem.hombres = 0;

                    data.push(dataItem);
                }

                dataItem.mujeres = response[i].total;
            }

            data.sort((a, b) => {
                if(a.comunidadAutonoma < b.comunidadAutonoma) { return -1; }
                if(a.comunidadAutonoma > b.comunidadAutonoma) { return 1; }
                return 0;
            });
            
            this.setState({
                cupsGasSex: data
            })
        })
    }

    private GetTotalMen(sexData: any[]) {
        const data = sexData.filter((value: any) => {
            return value.hombres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.hombres;
        }, 0);

        return sum;
    }

    private GetTotalWomen(sexData: any[]) {
        const data = sexData.filter((value: any) => {
            return value.mujeres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.mujeres;
        }, 0);

        return sum;
    }
}